import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Card, IconButton } from "@mui/material";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import React from "react";
import { converterURLImagemProduto } from "../../../utils/index";

export default function ImagemCard({
  imagem,
  handleDelete,
  handleOrdemAdicionar,
  handleOrdemSubtrair,
}) {
  return (
    <Card>
      <CardMedia
        sx={{ height: 160, objectFit: "contain" }}
        image={converterURLImagemProduto(imagem)}
        title={`Public ID ${imagem.publicId}`}
        component="img"
      />
      <CardContent>
        <Box display="block" textAlign="center">
          <Typography variant="body2" color="textSecondary" component="p">
            (ordem {imagem.ordem})
          </Typography>
        </Box>
      </CardContent>
      <CardActions disableSpacing>
        <Box display="flex" style={{ width: "100%" }}>
          <Box>
            <IconButton
              onClick={() => handleOrdemSubtrair(imagem)}
              size="large"
            >
              <ChevronLeftIcon />
            </IconButton>
          </Box>

          <Box flexGrow={1} textAlign="center">
            <IconButton onClick={() => handleDelete(imagem)} size="large">
              <DeleteIcon />
            </IconButton>
          </Box>

          <Box>
            <IconButton
              onClick={() => handleOrdemAdicionar(imagem)}
              size="large"
            >
              <ChevronRightIcon />
            </IconButton>
          </Box>
        </Box>
      </CardActions>
    </Card>
  );
}
